import { Empty } from 'antd';

export function PlanScheduleTab() {
  return <Empty description="Раздел находится в разработке" />;
}
